import { render, staticRenderFns } from "./EditAvatar.vue?vue&type=template&id=6f30f4c6&scoped=true"
import script from "./EditAvatar.vue?vue&type=script&lang=js"
export * from "./EditAvatar.vue?vue&type=script&lang=js"
import style0 from "./EditAvatar.vue?vue&type=style&index=0&id=6f30f4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f30f4c6",
  null
  
)

export default component.exports